// @flow
import { getWindowSize, setWindowSize } from '../../redux/modules/windowSize';
import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import WindowSizeListener from 'react-window-size-listener';

const mapStateToProps = state => {
    const windowSize = getWindowSize(state);
    return {
        windowHeight: windowSize.height,
        windowWidth: windowSize.width,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setWindowSize,
        },
        dispatch
    );

type Props = {
    setWindowSize: Function,
    windowHeight: number,
    windowWidth: number,
};

class WindowSizeContainer extends PureComponent<Props> {
    onResize = windowSize => {
        if (this.props.windowHeight !== windowSize.windowHeight || this.props.windowWidth !== windowSize.windowWidth) {
            this.props.setWindowSize({
                height: windowSize.windowHeight,
                width: windowSize.windowWidth,
            });
        }
    };

    render() {
        return <WindowSizeListener onResize={this.onResize} />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WindowSizeContainer);
